import { beforeAlliedAttack, defineGameCard, oncePerRound, roundMarkerStatus, } from '../authoring/index.js';
const SUPPORT_ROUND_KEY = '@cards/ability/royal_crossbowman/first_support_shot/round';
export const RoyalCrossbowmanCard = defineGameCard({
    id: 'royal_crossbowman',
    gameplay: {
        type: 'UNIT', cost: 3, baseStats: { attack: 2, health: 3 }, keywords: ['RUSH'],
    },
    presentation: {
        name: 'Королевский арбалетчик',
        description: 'Натиск. Первый раз за раунд перед атакой другой вашей карты Арбалетчик наносит 1 урон её цели.',
        glyph: {
            colors: ['#10213A', '#372E28', '#4E4337', '#593C22', '#88421F'],
            rows: [
                '....................',
                '......11111.........',
                '.....1233331........',
                '.....1233111..1.....',
                '.....1223331.131....',
                '.....1222231..131...',
                '.....1122221...131..',
                '....14411111...131..',
                '...111112411.1.1351.',
                '..133333255555555551',
                '..11222224222221151.',
                '....11111121...131..',
                '.....1222211...131..',
                '......124421...121..',
                '.....1444441..121...',
                '.....1422221.131....',
                '....11424221..1.....',
                '....11111211........',
                '....121..121........',
                '....111..111........',
            ],
        },
    },
    role: 'playable',
    abilities: [
        beforeAlliedAttack(oncePerRound({
            abilityId: 'first_support_shot',
            trigger: 'beforeAlliedAttack',
            when: () => true,
            run: (ctx, planned) => {
                ctx.ops.dealDamage(planned.target, 1);
            },
        })),
    ],
    ui: {
        mechanics: ['rush'],
        publicVars: { supportRound: { key: SUPPORT_ROUND_KEY, kind: 'number' } },
        statusProviders: [roundMarkerStatus({
                fact: 'supportRound',
                id: 'royal-crossbowman-support-used',
                symbol: '➶',
                label: 'Поддержка использована',
                description: 'Арбалетчик уже сделал поддерживающий выстрел в этом раунде.',
                tone: 'neutral',
            })],
    },
});
//# sourceMappingURL=royal_crossbowman.js.map